import { type Signal, useSignal } from '@preact/signals-react'

export const useDebouncedSignal = <T>(
  state: Signal<T>,
  delay = 1000,
): Signal<T> => {
  const debouncedState = useSignal<T>(state.value)

  let timeoutId: ReturnType<typeof setTimeout> | null = null

  state.subscribe((newValue) => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    timeoutId = setTimeout(() => {
      debouncedState.value = newValue
    }, delay)
  })

  return debouncedState
}
